import validator from 'ui-validator';
import { VALID_HOME_STATUS_EXPENSE } from '../../../../shared_modules/baui-constants';

const v = validator.validators;

const requiredExpense = (value, key, attributes) => {
  const { homeStatus } = attributes;
  if (VALID_HOME_STATUS_EXPENSE.includes(homeStatus)) {
    if (!value) return v.required({ message: 'An amount is required.' })(value, key, attributes);
    return v.dollarAmountRange({
      min: 0,
      max: 99999,
      overMaxMessage: 'The amount you have entered is above the maximum allowed.',
    })(value, key, attributes);
  }
};

const validations = {
  homeStatus: {
    required: v.required({ message: 'A selection is required.' }),
    suspicious: v.suspicious(),
  },
  homeStatusExpense: {
    validate: requiredExpense,
    suspicious: v.suspicious(),
  },
};

export default validations;

